import axios from 'axios'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { container } from 'inversify-props'
import 'reflect-metadata'
import { CaseInterviewSharesClient, InterviewsClient, TenantsClient } from 'ritem-common'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { API_ENDPOINT } from './services/environment'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.config.productionTip = false

container.addSingleton(
  () => new InterviewsClient(API_ENDPOINT, axios),
  'InterviewsClient'
)

container.addSingleton(
  () => new CaseInterviewSharesClient(API_ENDPOINT, axios),
  'CaseInterviewSharesClient'
)

container.addSingleton(
  () => new TenantsClient(API_ENDPOINT, axios),
  'TenantsClient'
)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
